<template>
    <div v-if=" allowedIso3Search ">
        <np-select2 v-if="selectMode"
                    :label="label"
                    @close="selected"
                    :parameters="addresses"
                    ref="select2"
                    :required="isRequired"
                    :open="select2Open"
                    @update:model-value="addressSelected">
        </np-select2>
        <np-input v-else
                  v-bind="$attrs"
                  @keyup.enter="search($event.target.value)"
                  @addon-click="search"
                  :label="label"
                  v-model="keyword"
                  ref="input"
                  :required="isRequired"
                  @update:model-value="val => $emit('update:modelValue', val)">
            <template #addon>
            <i v-if="searching" class="fa fa-spinner fa-spin"></i>
            <i v-else class="fa fa-search"></i>
            </template>
        </np-input>
    </div>
    <div v-else>
        <np-input
                  v-bind="$attrs"
                  :label="label"
                  v-model="keyword"
                  ref="input"
                  :required="isRequired"
                  :disabled="disable_if_no_search"
                  @update:model-value="val => $emit('update:modelValue', val)">
        </np-input>
    </div>
</template>

<script>
    import NPInput from './np-input.vue';
    import NPSelect from './np-select2.vue';

    export default {
        name: 'np-postcode-search',
        props: {
            label: String,
            modelValue: String,
            iso3: String,
            check_config: {
                default: true
            },
            refType: String,
            reference: {},
            postcode_only: {
                default: true
            },
            iso3_allowed_search: {
                default: []
            },
            disable_if_no_search: {
                default: false
            }
        },
        components: {
            'np-input': NPInput,
            'np-select2': NPSelect,
        },
        data: function () {
            return {
                selectMode: false,
                addresses: [],
                select2Open: false,
                searching: false,
                keyword: '',
                page_config_required: false,
                postcode_cache: {},
            }
        },
        created: function () {
            // This component should word without v-model binding
            this.keyword = this.modelValue;
        },
        mounted: function () {
        },
        computed: {
            isRequired: function () {
                return this.check_config ? !!this.page_config_required : !!this.required;
            },
            allowedIso3Search: function() {
                const allowed_default_iso3 = ['DEU', 'DNK', 'IRL', 'FIN', 'GBR', 'NOR', 'POL', 'SWE'];
                const allowed_countries = (Array.isArray(this.iso3_allowed_search) && this.iso3_allowed_search.length > 0) ? this.iso3_allowed_search : allowed_default_iso3;
                if( !!this.iso3 && allowed_countries.find( iso3 => { return iso3 === this.iso3 } ) ){
                    return true
                }else {
                    return false
                }
            }
        },
        methods: {
            selected: function () {
                this.selectMode = false;
                this.select2Open = false;
            },
            addressSelected: function (addressIndex) {
                const address = this.addresses[addressIndex];
                this.$emit('address-selected', address);
            },
            search: function (postcode) {
                let payload = {
                    contact_postcode: postcode,
                    objectId: 'store_address_zip_code',
                };
                payload = {...payload, ...this.reference}
                if (this.iso3) {
                    payload['iso3'] = this.iso3
                }
                // const configs = {
                //     headers: {'X-Requested-With': 'XMLHttpRequest'}
                // };
                const vm = this;
                payload['postcode_only'] = vm.postcode_only ? '1' : '0';
                let setPostCode = function (data) {
                    vm.selectMode = true;
                    vm.addresses = data.item;
                    if (data.item.length === 0) {
                        vm.$emit('empty-address', true);
                    }
                    $(vm.$refs.select2).click()
                    vm.$nextTick(function () {
                        vm.select2Open = true;
                    })
                };

                let cache_key = postcode + "_" + this.iso3;
                if (this.postcode_cache.hasOwnProperty(cache_key) && this.objectIsNotEmpty(this.postcode_cache[cache_key].item) && this.postcode_cache[cache_key].item.length > 0) {
                    setPostCode(this.postcode_cache[cache_key]);
                } else {
                    this.searching = true;

                    this.getAxiosInstance().post('/externalservices/getaddresses', payload)  //, configs)
                        .then(response => {
                            const data = response.data;
                            this.postcode_cache[cache_key] = data;
                            setPostCode(data);
                            this.searching = false;
                        })
                        .catch(error => {
                            console.error(error);
                            this.searching = false;
                        })
                }
            }
        },
        watch: {
            modelValue: function (val) {
                this.keyword = val;
            },
            isRequired: function(val) {
                if(!!this.$refs['input']) {
                    this.$refs['input']['page_config_required'] = val;
                }
                if(!!this.$refs['select2']) {
                    this.$refs['select2']['page_config_required'] = val;
                }
            }
        }
    }
</script>

<style scoped>

</style>